import { Suspense } from 'react';
import { Link, Outlet } from 'react-router-dom';

import { Spinner } from '../ui/index.js';
import { useAuth, roleHome } from '../lib/auth.js';
import { ErrorBoundary } from './ErrorBoundary.js';
import { Logo } from './Logo.js';
import { OfflineBanner } from './OfflineBanner.js';

/**
 * The public layout for the landing page, sign in, sign up, status screens, and
 * the showcase gallery. Signed-in visitors get a shortcut back to their home.
 */
export function PublicShell() {
  const { me, status } = useAuth();

  return (
    <div className="pt-shell">
      <OfflineBanner />
      <header className="pt-topnav">
        <div className="pt-topnav__inner">
          <Logo to="/" />
          <div className="pt-topnav__spacer" />
          <div className="pt-topnav__actions">
            <Link to="/showcase" className="pt-navlink">
              Explore
            </Link>
            {status === 'authed' && me ? (
              <Link to={roleHome(me.role)} className="pt-btn pt-btn--primary pt-btn--sm">
                Go to my space
              </Link>
            ) : status === 'anon' ? (
              <>
                <Link to="/login" className="pt-btn pt-btn--ghost pt-btn--sm">
                  Log in
                </Link>
                <Link to="/signup" className="pt-btn pt-btn--primary pt-btn--sm">
                  Sign up
                </Link>
              </>
            ) : null}
          </div>
        </div>
      </header>

      <main className="pt-public-main">
        <ErrorBoundary>
          <Suspense
            fallback={
              <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--pt-space-7)' }}>
                <Spinner size={30} label="Loading" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
    </div>
  );
}
